import { useEffect, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Simple analytics tracker
const trackEvent = async (eventType, data = {}) => {
  try {
    await axios.post(`${API}/analytics/event`, {
      event_type: eventType,
      page: window.location.pathname,
      ...data
    });
  } catch (error) {
    // Silently fail - analytics shouldn't break the app
    console.debug('Analytics tracking failed:', error);
  }
};

// Track page views
export const trackPageView = (page, product = null) => {
  trackEvent('page_view', { page, product });
};

// Track button clicks
export const trackClick = (element, metadata = {}) => {
  trackEvent('button_click', { element, metadata });
};

// Track form submissions
export const trackFormSubmit = (formName, product = null, metadata = {}) => {
  trackEvent('form_submit', { element: formName, product, metadata });
};

// Track signups
export const trackSignup = (product, metadata = {}) => {
  trackEvent('signup', { product, metadata });
};

// Hook for automatic page view tracking
export const usePageTracking = (product = null) => {
  useEffect(() => {
    trackPageView(window.location.pathname, product);
  }, [product]);
};

// Hook that returns tracking functions
export const useAnalytics = () => {
  const track = useCallback((eventType, data = {}) => {
    trackEvent(eventType, data);
  }, []);

  return {
    trackPageView,
    trackClick,
    trackFormSubmit,
    trackSignup,
    track
  };
};

export default useAnalytics;
